module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-800.a6d9cbaf.jpg";